<template>
  <Button class="p-button-rounded p-button-text" :disabled="disabled" @click="toggle">
    <VdIcon store="fa" name="ellipsis-h" size="large" color="var(--vd-color-blue-default)"></VdIcon>
  </Button>
  <MenuComponent ref="menuRef" :model="items" :popup="true">
    <template #item="{ item, props }">
      <a class="flex align-items-center" v-bind="props.action">
        <i :class="item.icon" />
        <span :class="$style.menuText">{{ item.label }}</span>
      </a>
    </template>
  </MenuComponent>
</template>

<script setup>
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import Button from "primevue/button";
import MenuComponent from "primevue/menu";
import { ref } from "vue";

const menuRef = ref();
defineProps({
  items: {
    type: Array,
    required: true,
    default: () => [],
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const toggle = (event) => {
  menuRef.value.toggle(event);
};
</script>

<style module>
.menuText {
  color: var(--vd-color-text-light-1);
  padding: 5px;
}
</style>
